import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { IoEllipsisVertical } from "react-icons/io5";
import { useTranslation } from "react-i18next";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

export const DropdownMenu = ({removeItem, onEditHandler , id}) => {
    const { t } = useTranslation();

    const onAddGroupHandler = ()=>{}
    
    return (
        <Menu as="div" >
            <div className="flex items-center">
                <Menu.Button>                    
                    <IoEllipsisVertical  size={25}  className="text-indigo-600"/>
                </Menu.Button>
            </div>

            <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
            >
                <Menu.Items className="absolute -right-52 top-3 z-10 mt-2 w-62 origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className="py-1">
                        <Menu.Item>
                            {({ active }) => (
                                <button
                                    type="button"
                                    onClick={()=>onEditHandler(id)}
                                    className={
                                    classNames(active
                                            ? "bg-gray-100 text-gray-900 w-full text-left"
                                            : "text-gray-700", "block px-4 py-2 text-sm w-full text-left"
                                    )}>{t("Edit")}</button>)}
                        </Menu.Item>
                        <Menu.Item>
                            {({ active }) => (
                                <button
                                    type="button"
                                    onClick={()=>removeItem(id)} 
                                    className={
                                    classNames(active
                                            ? "bg-gray-100 text-gray-900 w-full text-left"
                                            : "text-gray-700", "block px-4 py-2 text-sm w-full text-left"
                                    )}>{t("Remove")}</button>)}
                        </Menu.Item>
                        <Menu.Item>
                            {({ active }) => (
                                <button
                                    type="button"
                                    onClick={onAddGroupHandler} 
                                    className={
                                    classNames(active
                                            ? "bg-gray-100 text-gray-900 whitespace-nowrap w-full text-left"
                                            : "text-gray-700", "block px-4 py-2 text-sm whitespace-nowrap w-full text-left"
                                    )}>{t("Add conditional modifier group")}</button>)}
                        </Menu.Item>                        
                    </div>
                </Menu.Items>
            </Transition>
        </Menu>
    );
};
